export enum ApiPermissionCategoryNames {
  adminPanel = 'admin_panel',
  auditConduction = 'audit_conduction'
}
